import { render, staticRenderFns } from "./indicators_tab.vue?vue&type=template&id=072d5a9e&scoped=true"
import script from "./indicators_tab.vue?vue&type=script&lang=js"
export * from "./indicators_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072d5a9e",
  null
  
)

export default component.exports